module.exports = __webpack_public_path__ + "static/assets/9317feaf9dcf49ddb24c960852de1372.svg";